import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import plusicon from "../../../assets/images/grayplus.svg";

function FaqBox({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  // Close the FAQ box whenever the page changes
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <li
      className="faq-box border bg-white rounded-[10px] border-solid border-[#DDE2E4] list-none px-6 py-4 mb-2 "
    >
      <h4
        className="faq-question flex justify-between items-center cursor-pointer"
        onClick={toggleAnswer}
        data-testid="faq-question"
      >
        <span className="text-black text-base not-italic font-medium leading-[150%]">{question}</span>
        <motion.span
          className="text-xl inline-flex shrink-0"
          animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.25, ease: "easeInOut" }}
          style={{ transformOrigin: "center center" }}
        >
          <img src={plusicon} alt="Toggle answer" className="icon max767:max-w-[32px] max767:h-[32px]" />
        </motion.span>
      </h4>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="faq-answer"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            style={{ overflow: "hidden" }}
          >
            <div className="faq-answer mt-2 text-black text-base not-italic font-normal leading-[150%]" data-testid="faq-answer">
              {answer?.split('<br>')?.map(each=> <p className="min-h-3">{each}</p> )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </li>
  );
}

export default FaqBox;
